<template>
  <GenericStep v-bind="$attrs">
    <IdentifiersCard
      :id="peSharedQESliderPartyId"
      class="mb-4"
      :item="peParty"
    />

    <div
      v-for="identifier of peParty.identifiers"
      :key="identifier.id"
      class="mb-12"
    >
      <AdditionalIdentifiersCard
        :id="peSharedQESliderPartyId"
        :item="identifier"
      />
    </div>

    <SectionAdderLine
      section="Identifier"
      :has-new-section="peAdditionalIdentifiersCardHasNewSection"
      @on-add="peAdditionalIdentifiersCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import AdditionalIdentifiersCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/AdditionalIdentifiersCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import IdentifiersCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/IdentifiersCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'IdentifiersStep',

  components: {
    AdditionalIdentifiersCard,
    GenericStep,
    IdentifiersCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return {
        additional_identifiers: this.peParty.identifiers,
        identifiers: pick(
          this.peParty, [
            'a_number',
            'no_a_number',
            'ssn',
            'no_ssn',
            'other_id',
            'identifiers_notes',
          ]
        ),
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAdditionalIdentifiersCardHasNewSection',
      'peParty',
      'peSharedQESliderPartyId',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peAdditionalIdentifiersCardAddSection',
    ]),
  },
}
</script>
